import React, { useState } from 'react';
import { Box, Card, Typography, Breadcrumbs, Divider, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useDispatch } from 'react-redux';
import { useResponseHandler } from 'hooks/useResponseHandler';
import formInitialValues from './formik/formInitialValues';
import validationSchema from './formik/validationSchema';
import planesFormModel from './formik/planesFormModel';
import { PlanesForm } from './components/forms/PlanesForm';
import { saveServicesIaPlanStore } from 'store/services-ia-plans/thunks';
import { MessagesDrawerRight } from 'components/MessagesDrawerRight';
import { servicesIaPlansMapper } from './mappers/services-ia-plans.mapper';

export const CreatePlanes = () => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { handleResponse, ResponseComponents } = useResponseHandler();
    const { formId, formField } = planesFormModel;
    const [dataErrors, setMsgErrors] = useState([]);

    const onSubmit = async (values: any, actions: any) => {
        const payload = servicesIaPlansMapper.toDto(values);
        const response = await dispatch(saveServicesIaPlanStore(payload));
        
        await handleResponse(response, 'Plan Creado Exitosamente', true);
        actions.setSubmitting(false);
        if (response?.ok) {
            actions.resetForm();
        }
    };

    return (
        <Box sx={{ width: '100%', mb: 5 }}>
            {ResponseComponents}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                <Box>
                    <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, color: 'text.primary' }}>
                        Crear Plan
                    </Typography>

                    <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
                        {/* <Typography color="textPrimary" sx={{ fontWeight: 700 }}>Planes IA</Typography> */}
                        <Link color="inherit" to="/manager/plataforma-ia/comercial/planes">
                            Planes IA
                        </Link>
                        <Typography color="textPrimary">Crear Plan</Typography>
                    </Breadcrumbs>

                </Box>
            </Box>

            <Card sx={{ p: 4, borderRadius: 3, boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)' }}>
                <Formik
                    initialValues={formInitialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                    enableReinitialize
                >
                    {(props) => (
                        <Form id={formId}>
                            <PlanesForm formField={formField} isEditing={false} />

                            <Divider sx={{ my: 4 }} />

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                <Button
                                    component={Link}
                                    to="/manager/servicios-ia/comercial/planes"
                                    variant="outlined"
                                    color="inherit"
                                    sx={{ borderRadius: 2, px: 3 }}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disabled={props.isSubmitting}
                                    sx={{ borderRadius: 2, px: 4, boxShadow: '0px 4px 10px rgba(105, 108, 255, 0.3)' }}
                                >
                                    {props.isSubmitting ? 'Guardando...' : 'Guardar Plan'}
                                </Button>
                            </Box>
                        </Form>
                    )}
                </Formik>
            </Card>

            <MessagesDrawerRight
                data={dataErrors}
                open={dataErrors.length > 0}
                setMsg={setMsgErrors}
            />
        </Box>
    );
};
